import { BaseService } from 'core/services';
import SalesOrderRouteService from './SalesOrderRouteService'

class SalesOrderService extends BaseService{
    constructor(apiClient) {
        super(apiClient, new SalesOrderRouteService());
    }
}

export default SalesOrderService;